export default class IframeUtil {
  constructor() {}

  static get inIframe(): boolean {
    return window.self !== window.top;
  }

  /*
   * Função responsável por comunicar ao componente de busca ncm
   * O código que foi selecionado na aplicação
   * sumario, nomenclatura e pesquisa.controller possuem a mesma função.
   */
  static messageToParent(message: any) {
    window.parent.postMessage(message, "*");
  }
}
